import React from "react";

import { LoadingIndicatorProps } from "@/interfaces";

const LoadingIndicator = ({ inProgress }: LoadingIndicatorProps): JSX.Element =>
    inProgress ? (
        <div className="loaderGifOuterWrapper">
            <div className="loaderGifWrapper">
                <div className="loaderGif" />
            </div>
        </div>
    ) : (
        <></>
    );

export default LoadingIndicator;
